<template>
  <footer class="bg-background-primary p-2 px-10">
    <p class="text-gray-100">
      Copyright © {{ new Date().getFullYear() }} Summit Professional Education, LLC. All Rights Reserved.
    </p>
  </footer>
</template>

<script>
export default {
  name: 'BlueFooter',
};
</script>
